import { render, staticRenderFns } from "./ArticleLoadingCard.vue?vue&type=template&id=27d01345&"
import script from "./ArticleLoadingCard.vue?vue&type=script&lang=js&"
export * from "./ArticleLoadingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports